// Single PostHog init for the app. Bundled `posthog-js` (not the CDN snippet)
// so capture/identify never depend on a CDN load and the SDK
// version is pinned in package.json. Import this module first in main.tsx.
import posthog from 'posthog-js'

const token = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN as string | undefined

if (token) {
  posthog.init(token, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    // api_host is our reverse proxy (e.pronteer.com); ui_host keeps toolbar /
    // replay links pointing at the PostHog app.
    ui_host: 'https://us.posthog.com',
    defaults: '2026-01-30',
    // The app's origin is capacitor://localhost, so the default localhost
    // rule would mark every real user as internal/test. Do not remove.
    internal_or_test_user_hostname: null,
    session_recording: {
      maskAllInputs: false,
    },
  })
}

export { posthog }
